<template>
  <div>
    <a-button type="danger" icon="search" @click="advancedSearch">
      高级搜索
    </a-button>
    <div>
      <popUp
        ref="advancedSearch"
        :dialog-visible="dialogVisible"
        @success="success"
        @save="save"
        @close="close"
      />
    </div>
  </div>
</template>

<script>
import popUp from './popUp.vue'
export default {
  components: {popUp},
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    advancedSearch () {
      this.$nextTick(() => {
        this.$refs.advancedSearch.getDept()
      })
      this.dialogVisible = true
    },
    success () {
      this.dialogVisible = false
      this.$emit('advancedSearch')
    },
    save () {
      this.dialogVisible = false
      this.$emit('save')
    },
    close () {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/advancedSearch/index.vue